<template>
  <article>
    <v-layout row wrap justify-space-around class="pa-3">
      <v-flex xs6 md3>
        <v-btn v-if="active" flat icon color="pink">
          <v-icon large class="error--text">warning</v-icon>
        </v-btn>
        <v-btn v-else flat icon color="green">
          <v-icon large color="success">done</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs6 md3>
        <div class="caption grey--text">Affected SLO</div>
        {{ sloName }}
      </v-flex>
      <v-flex xs6 md3>
        <div class="caption grey--text">App Name</div>
        <div class="subheading">{{ appName }}</div>
      </v-flex>
      <v-flex xs6 md3>
        <span v-if="active">
            <div class="caption grey--text">Since</div>
            {{ startTime }}
        </span>
        <span v-else>
            <div class="caption grey--text">Was Active</div>
            {{ startTime }} - {{ endTime }}
        </span>
      </v-flex>
    </v-layout>
  </article>
</template>

<script>
var moment = require("moment");

export default {
  name: "AlertSummary",
  props: {
    incident: {
      type: Object,
      required: true
    },
    appName: {
      type: String,
      required: true
    },
    sloName: {
      type: String,
      required: true
    }
  },
  computed: {
    startTime() {
      return moment(this.incident.started).calendar();
    },
    endTime() {
      if (!this.incident.ended) {
        return null;
      }

      return moment(this.incident.ended).calendar();
    },
    active() {
      return this.incident.ended == null;
    }
  }
};
</script>
